import { enums, SiteScheduleIndex } from '@nimbly-technologies/nimbly-common';

type ActivePeriodFields = Pick<SiteScheduleIndex, 'type' | 'isAdhocOnly' | 'scheduleActivePeriod'>;

const isAdhocOnlySchedule = (schedule: ActivePeriodFields): boolean =>
	schedule.type === enums.ScheduleTypes.CUSTOM && Boolean(schedule.isAdhocOnly);

export const activePeriodForUpload = (schedule: ActivePeriodFields): SiteScheduleIndex['scheduleActivePeriod'] =>
	isAdhocOnlySchedule(schedule) ? null : schedule.scheduleActivePeriod;

/**
 * Active period widens a dated schedule's window, so an ad-hoc-only schedule (which has no dates,
 * and whose editor hides the active period input) never needs one.
 */
export const isActivePeriodIncomplete = (schedule: ActivePeriodFields): boolean => {
	if (isAdhocOnlySchedule(schedule)) {
		return false;
	}
	const activePeriod = schedule.scheduleActivePeriod;
	return Boolean(activePeriod) && (!activePeriod?.periodUnit || !activePeriod?.periodLength);
};
